import { NgModule } from '@angular/core';
import { PreloaderComponent } from './preloader/preloader.component'
import { TrialOverComponent } from './trial-over/trial-over.component'

@NgModule({
  declarations: [
    PreloaderComponent,
    TrialOverComponent
  ],
  exports: [
    PreloaderComponent,
    TrialOverComponent
  ]
})
export class ComponentsModule { }
